export default __webpack_public_path__ + "6e2494fb52f9ca366c844eaaf724a9df.jpeg";